import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

/** Floating cart button pinned bottom-left; only shows once the cart has items. */
const CartFloatingButton = () => {
  const { itemCount, setDrawerOpen } = useCart();
  if (itemCount === 0) return null;

  return (
    <button
      onClick={() => setDrawerOpen(true)}
      className="fixed bottom-24 left-6 z-50 bg-[#EC008C] hover:bg-[#FF3399] text-black rounded-full w-14 h-14 shadow-lg shadow-[#EC008C]/40 flex items-center justify-center transition-transform hover:scale-105"
      data-testid="cart-floating-button"
      aria-label={`Open cart · ${itemCount} items`}
    >
      <ShoppingBag className="w-6 h-6" />
      <span
        className="absolute -top-1 -right-1 bg-black text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-[#EC008C]"
        data-testid="cart-floating-count"
      >
        {itemCount}
      </span>
    </button>
  );
};

export default CartFloatingButton;
